<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <div v-if="riskSurveyMode === 'Query'">
                <v-icon>mdi-magnify</v-icon>
              </div>
              <div v-if="riskSurveyMode === 'Review'">
                <v-icon>mdi-pencil</v-icon>
              </div>
              <div v-if="riskSurveyMode === 'New'">
                <v-icon>mdi-plus</v-icon>
              </div>
              <v-toolbar-title v-if="riskSurveyMode !== 'New'" class="toolbar-title-2"
                >{{ riskSurveyMaster.survNo }} / {{ riskSurveyMaster.verCnt }}
                {{ riskSurveyMaster.insdName === undefined ? '' : ' - ' + riskSurveyMaster.insdName }}</v-toolbar-title
              >
              <v-toolbar-title v-else class="toolbar-title-2">New Risk Survey</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click.native="doReportAttach">
                <v-icon left dark>mdi-attachment</v-icon>
                <span>Attachments</span>
              </v-btn>
            </v-toolbar>
            <v-tabs show-arrows="" v-model="riskSurveyTabs">
              <v-tab @click.native="doTab(0)">Header</v-tab>
              <v-tab @click.native="doTab(1)">Construction</v-tab>
              <v-tab @click.native="doTab(2)">Surroundings</v-tab>
              <v-tab @click.native="doTab(3)">Lighting</v-tab>
              <v-tab @click.native="doTab(4)">Fire Prevention</v-tab>
              <v-tab @click.native="doTab(5)">Management</v-tab>
              <v-tab @click.native="doTab(6)">Interest Insured</v-tab>
              <v-tab @click.native="doTab(7)">Occupation</v-tab>
              <v-tab @click.native="doTab(8)">Fire Attachment</v-tab>
              <v-tab @click.native="doTab(9)">Stock Description</v-tab>
              <v-tab @click.native="doTab(10)">Premises Description</v-tab>
              <v-tab @click.native="doTab(11)">Entrance</v-tab>
              <v-tab @click.native="doTab(12)">Safe Room</v-tab>
              <v-tab @click.native="doTab(13)">Burglary Attachment</v-tab>
            </v-tabs>
            <v-layout row wrap>
              <v-flex xs12>
                <router-view ref="childComponent"></router-view>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-btn class="mt-2" color="error" dark @click.prevent="doExit">
                {{ actionLabel.exit }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
              <v-btn class="mt-2 ml-2" v-if="riskSurveyMode !== 'Query'" color="info" dark @click.prevent="doReset">
                {{ actionLabel.reset }}
                <v-icon dark right>mdi-refresh</v-icon>
              </v-btn>
              <v-btn class="mt-2 ml-2" v-if="riskSurveyMode !== 'Query'" color="primary" dark @click.prevent="doSave" :loading="submitting">
                {{ actionLabel.save }}
                <v-icon dark right>mdi-content-save</v-icon>
              </v-btn>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog v-model="showReportAttach" width="1000px">
        <survey-report-attach v-if="showReportAttach" :survNoParam="survNoParam" @close="showReportAttach = false"></survey-report-attach>
      </v-dialog>

      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred when creating Credit Note.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- <prompt-leave v-if="showPromptLeave" title="Risk Survey" v-model="promptLeave" @exit="doExit" @saveAndExit="doSaveAndExit"></prompt-leave> -->
    </v-container>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { RISK_SURVEY_TAB } from '@/store/types'
import clone from 'clone'
import { removeFormatNumber } from '@/utils/number'
import SurveyReportAttach from './SurveyReportAttach'
import { removeTime } from '@/utils/date'
// import { promptOnExitMixin } from '@/mixins/common/promptOnExitMixin'
// import PromptLeave from '@/components/core/common/prompt/PromptLeave'

export default {
  data() {
    return {
      actionLabel: {
        exit: 'Exit',
        reset: 'Reset',
        save: 'Save'
      },
      formParam: undefined,
      survDetForm: {},
      loading: false,
      showErrorDialog: false,
      submitting: false,
      showPromptLeave: true,
      riskSurveys: 0,
      riskSurveyTabs: 0,
      riskSurveyApiUrl: '',
      showReportAttach: false,
      survNoParam: null
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    riskSurveyTab: function (value) {
      this.riskSurveys = value
      this.riskSurveyTabs = this.riskSurveyTab
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyTab() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyTab
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    },
    doDisabledTab() {
      return this.riskSurveyMode === 'New'
    }
  },
  methods: {
    doInit() {
      this.$store.commit(RISK_SURVEY_TAB, 0)
      this.riskSurveys = this.riskSurveyTab
      this.riskSurveyTabs = this.riskSurveyTab
      this.changeTab(this.riskSurveyTab)
      this.survNoParam = this.riskSurveyMaster.survNo
    },
    async doSave() {
      this.doStoreData()
      this.$refs.childComponent.$validator.validateAll(this.formParam).then((result) => {
        if (result) {
          this.doSaveSurveyMaster().then((result2) => {
            if (result2) {
              this.$refs.childComponent.$validator.validateAll(this.formParam).then((result3) => {
                if (result3) {
                  this.doSaveSurveyDet()
                }
              })
            }
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doSaveSurveyMaster() {
      if (this.riskSurveyMode === 'New') {
        this.riskSurveyApiUrl = this.riskSurveyMenu.createRiskSurvey
      } else {
        this.riskSurveyApiUrl = this.riskSurveyMenu.updateRiskSurvey
      }
      if (this.riskSurveyApiUrl) {
        this.submitting = true
        try {
          let result = ''
          let expand = clone(this.riskSurveyMaster)
          if (expand.survDate) {
            expand.survDate = removeTime(expand.survDate)
          }
          if (this.riskSurveyMode === 'New') {
            this.riskSurveyApiUrl = this.riskSurveyMenu.createRiskSurvey
            result = await this.$http.post(this.riskSurveyApiUrl, expand)
          } else {
            this.riskSurveyApiUrl = this.riskSurveyMenu.updateRiskSurvey
            result = await this.$http.put(this.riskSurveyApiUrl, expand)
          }
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
          return true
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            return false
          }
        }
      }
    },
    async doSaveSurveyDet() {
      const apiURI = this.riskSurveyMenu.saveSurvDet
      if (apiURI) {
        this.submitting = true
        try {
          let expand = clone(this.riskSurveyDetails)
          expand.survNo = this.riskSurveyMaster.survNo
          expand.verCnt = this.riskSurveyMaster.verCnt
          if (this.riskSurveyMode === 'New') {
            expand.survDetType = 'All'
          }
          // Interest Insured here
          if (expand.insdBldg) {
            expand.insdBldg = removeFormatNumber(expand.insdBldg)
          }
          if (expand.insdCont) {
            expand.insdCont = removeFormatNumber(expand.insdCont)
          }
          if (expand.insdPlt) {
            expand.insdPlt = removeFormatNumber(expand.insdPlt)
          }
          if (expand.insdRawMat) {
            expand.insdRawMat = removeFormatNumber(expand.insdRawMat)
          }
          if (expand.insdGoods) {
            expand.insdGoods = removeFormatNumber(expand.insdGoods)
          }
          if (expand.insdPackMat) {
            expand.insdPackMat = removeFormatNumber(expand.insdPackMat)
          }
          // Stock Description here
          if (expand.stkVal) {
            expand.stkVal = removeFormatNumber(expand.stkVal)
          }
          if (expand.highVal) {
            expand.highVal = removeFormatNumber(expand.highVal)
          }
          const result = await this.$http.post(apiURI, expand)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
          return true
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            return true
          }
        }
      }
    },
    doReportAttach() {
      this.showReportAttach = true
    },
    doReset() {
      this.$refs.childComponent.doReset()
    },
    doExit() {
      this.$store.commit(RISK_SURVEY_TAB, 0)
      this.$router.push({ name: 'riskSurveyListing' })
    },
    async doTab(tab) {
      this.resetMessages()
      this.riskSurveys = tab
      this.$store.commit(RISK_SURVEY_TAB, this.riskSurveys)
      this.doStoreData()
      this.changeTab(this.riskSurveyTab)
    },
    async doStoreData() {
      if (this.riskSurveys === 0) {
        this.formParam = 'headerForm'
      } else if (this.riskSurveys === 1) {
        this.formParam = 'constnForm'
      } else if (this.riskSurveys === 2) {
        this.formParam = 'surrForm'
      } else if (this.riskSurveys === 3) {
        this.formParam = 'lightForm'
      } else if (this.riskSurveys === 4) {
        this.formParam = 'firePrevForm'
      } else if (this.riskSurveys === 5) {
        this.formParam = 'mgmtForm'
      } else if (this.riskSurveys === 6) {
        this.formParam = 'insInsdForm'
      } else if (this.riskSurveys === 7) {
        this.formParam = 'occpnForm'
      } else if (this.riskSurveys === 8) {
        this.formParam = 'fireAttchForm'
      } else if (this.riskSurveys === 9) {
        this.formParam = 'stockDescForm'
      } else if (this.riskSurveys === 10) {
        this.formParam = 'premDescForm'
      } else if (this.riskSurveys === 11) {
        this.formParam = 'entForm'
      } else if (this.riskSurveys === 12) {
        this.formParam = 'safeForm'
      } else if (this.riskSurveys === 13) {
        this.formParam = 'burgForm'
      }
      if (this.$refs.childComponent.headerForm !== undefined) {
        this.$store.dispatch('storeSurveyMaster', this.$refs.childComponent.headerForm)
      }
      if (this.$refs.childComponent.constnForm !== undefined) {
        this.$store.dispatch('storeSurveyDetails', this.$refs.childComponent.constnForm)
      }
      if (this.$refs.childComponent.surrForm !== undefined) {
        this.$store.dispatch('storeSurveyDetails', this.$refs.childComponent.surrForm)
      }
      if (this.$refs.childComponent.lightForm !== undefined) {
        this.$store.dispatch('storeSurveyDetails', this.$refs.childComponent.lightForm)
      }
      if (this.$refs.childComponent.firePrevForm !== undefined) {
        this.$store.dispatch('storeSurveyDetails', this.$refs.childComponent.firePrevForm)
      }
      if (this.$refs.childComponent.mgmtForm !== undefined) {
        this.$store.dispatch('storeSurveyDetails', this.$refs.childComponent.mgmtForm)
      }
      if (this.$refs.childComponent.insInsdForm !== undefined) {
        let expand = clone(this.$refs.childComponent.insInsdForm)
        if (expand.insdBldg) {
          expand.insdBldg = removeFormatNumber(expand.insdBldg)
        }
        if (expand.insdCont) {
          expand.insdCont = removeFormatNumber(expand.insdCont)
        }
        if (expand.insdPlt) {
          expand.insdPlt = removeFormatNumber(expand.insdPlt)
        }
        if (expand.insdRawMat) {
          expand.insdRawMat = removeFormatNumber(expand.insdRawMat)
        }
        if (expand.insdGoods) {
          expand.insdGoods = removeFormatNumber(expand.insdGoods)
        }
        if (expand.insdPackMat) {
          expand.insdPackMat = removeFormatNumber(expand.insdPackMat)
        }
        this.$store.dispatch('storeSurveyDetails', expand)
      }
      if (this.$refs.childComponent.occpnForm !== undefined) {
        this.$store.dispatch('storeSurveyDetails', this.$refs.childComponent.occpnForm)
      }
      if (this.$refs.childComponent.fireAttchForm !== undefined) {
        this.$store.dispatch('storeSurveyDetails', this.$refs.childComponent.fireAttchForm)
      }
      if (this.$refs.childComponent.stockDescForm !== undefined) {
        let expand = clone(this.$refs.childComponent.stockDescForm)
        if (expand.stkVal) {
          expand.stkVal = removeFormatNumber(expand.stkVal)
        }
        if (expand.highVal) {
          expand.highVal = removeFormatNumber(expand.highVal)
        }
        this.$store.dispatch('storeSurveyDetails', expand)
      }
      if (this.$refs.childComponent.premDescForm !== undefined) {
        this.$store.dispatch('storeSurveyDetails', this.$refs.childComponent.premDescForm)
      }
      if (this.$refs.childComponent.entForm !== undefined) {
        this.$store.dispatch('storeSurveyDetails', this.$refs.childComponent.entForm)
      }
      if (this.$refs.childComponent.safeForm !== undefined) {
        this.$store.dispatch('storeSurveyDetails', this.$refs.childComponent.safeForm)
      }
      if (this.$refs.childComponent.burgForm !== undefined) {
        this.$store.dispatch('storeSurveyDetails', this.$refs.childComponent.burgForm)
      }
    },
    changeTab() {
      if (this.riskSurveys === 0) {
        this.$router.push({ name: 'riskSurveyHeader' })
      } else if (this.riskSurveys === 1) {
        this.$router.push({ name: 'riskSurveyConstn' })
      } else if (this.riskSurveys === 2) {
        this.$router.push({ name: 'riskSurveySurr' })
      } else if (this.riskSurveys === 3) {
        this.$router.push({ name: 'riskSurveyLight' })
      } else if (this.riskSurveys === 4) {
        this.$router.push({ name: 'riskSurveyFirePrev' })
      } else if (this.riskSurveys === 5) {
        this.$router.push({ name: 'riskSurveyMgmt' })
      } else if (this.riskSurveys === 6) {
        this.$router.push({ name: 'riskSurveyInsInsd' })
      } else if (this.riskSurveys === 7) {
        this.$router.push({ name: 'riskSurveyOccp' })
      } else if (this.riskSurveys === 8) {
        this.$router.push({ name: 'riskSurveyFireAttch' })
      } else if (this.riskSurveys === 9) {
        this.$router.push({ name: 'riskSurveyStockDesc' })
      } else if (this.riskSurveys === 10) {
        this.$router.push({ name: 'riskSurveyPremDesc' })
      } else if (this.riskSurveys === 11) {
        this.$router.push({ name: 'riskSurveyEnt' })
      } else if (this.riskSurveys === 12) {
        this.$router.push({ name: 'riskSurveySafe' })
      } else if (this.riskSurveys === 13) {
        this.$router.push({ name: 'riskSurveyBurg' })
      }
    }
  },
  created() {},
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [
    MessageMixin
    // promptOnExitMixin
  ],
  components: {
    SurveyReportAttach
    // PromptLeave
  }
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
